import { useEffect, useRef } from 'react';

// Runs `callback` immediately, then every `intervalMs`. Pauses while the tab
// is hidden (Page Visibility API) and resumes with an immediate refetch when
// it becomes visible again, so background/minimized tabs stop generating
// network traffic instead of polling forever.
const usePolling = (callback, intervalMs) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    let intervalId = null;

    const tick = () => callbackRef.current();

    const start = () => {
      if (intervalId) return;
      tick();
      intervalId = setInterval(tick, intervalMs);
    };

    const stop = () => {
      if (!intervalId) return;
      clearInterval(intervalId);
      intervalId = null;
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') stop();
      else start();
    };

    if (document.visibilityState !== 'hidden') start();
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      stop();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [intervalMs]);
};

export default usePolling;
